import { CLOSED_WITH_BALANCE, OPEN, SETPAY_LOANS, } from "../../../const/products";
/**
 * Determines if the Account Service button should be displayed
 * - MUST NOT HAVE any of the following to be displayed:
 * >- Be a setpay loan product type
 * >- Be in a CAP or settlement
 * >- Be a closed account with 0 or negative balance
 *
 * @param accountSummary Optional AccountSummaryGetResponse from v2 account summary API
 * @returns boolean value to show/hide the Account Service button
 */
var shouldShowAccountServiceButton = function (_a) {
    var _b;
    var accountSummary = _a.accountSummary, featuresData = _a.featuresData;
    if (!accountSummary)
        return false;
    var isAccountServicingEnabled = featuresData === null || featuresData === void 0 ? void 0 : featuresData.accountServicingEnabled;
    if (((_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.clientId) === "cb" && !isAccountServicingEnabled)
        return false;
    var conditions = accountSummary.conditions, currentBalance = accountSummary.credit.currentBalance, productType = accountSummary.product.type, _c = accountSummary.billing, customerAssistancePlan = _c.customerAssistancePlan, settlementEnrolled = _c.settlementEnrolled;
    var isOpen = conditions === null || conditions === void 0 ? void 0 : conditions.includes(OPEN);
    var isClosedWithBalance = conditions === null || conditions === void 0 ? void 0 : conditions.includes(CLOSED_WITH_BALANCE);
    var isCurrentBalanceZeroOrNegative = Number(currentBalance) <= 0;
    /*
     *Given the account is SetPay 1.0 or SetPay 2.0
     *and "accountServicingEnabled" property is False
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=10-,SetPay%20Clients,-Setpay%20Accounts%20Are
     */
    var isSetPay = productType && SETPAY_LOANS.includes(productType);
    /*
     *Given account status = OPEN or CLOSED_WITH_BALANCE
     *and enrolled flags are "customerAssistancePlan" = TRUE or "settlementEnrolled" = TRUE
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=Enrolled%20In%20CAP%20Accounts
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=Enrolled%20In%20Settlement%20Accounts
     */
    var isEnrolled = customerAssistancePlan || settlementEnrolled;
    var isCAPOrSettlement = (isOpen || isClosedWithBalance) && isEnrolled;
    /*
     *Given "condition" property for account is CLOSED_WITH_BALANCE
     *and "currentBalance" property is zero or negative
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=11-,Closed%20Accounts,-Closed%C2%A0Accounts
     */
    var isClosedWithZeroAndNegativeBalance = isClosedWithBalance && isCurrentBalanceZeroOrNegative;
    return !(isSetPay || isCAPOrSettlement || isClosedWithZeroAndNegativeBalance);
};
export default shouldShowAccountServiceButton;
//# sourceMappingURL=shouldShowAccountServiceButton.js.map